import { Loader2 } from 'lucide-react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'

import { Button } from '@/modules/shared/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/modules/shared/components/ui/dialog'
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
} from '@/modules/shared/components/ui/form'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/modules/shared/components/ui/select'

import { useOrderFormStore } from '../../../stores/order-form.store'
import { deletePdfService } from '../../../services/delete-pdf.service'
import { useOrderSearchData } from '../../../data/order-search.data'

type TModalPDFDownloadComponent = {
	isOpen: boolean
	onClose: () => void
}

export function ModalPDFDownloadComponent({
	isOpen,
	onClose,
}: TModalPDFDownloadComponent) {
	const [isSuccessPDFDownload, setIsSuccessPDFDownload] = useState(false)
	const form = useForm({
		defaultValues: {
			modelOfPDF: '1',
		},
	})

	const orderSearchData = useOrderSearchData()

	const { orderSelected } = useOrderFormStore()

	const handleOpenPDF = async () => {
		const data = await orderSearchData.action.onSubmitOrderPdf({
			payload: {
				orderId: String(orderSelected?.idPedidoCel),
				fkUsuarioxDispositivo: orderSelected?.fkUsuarioxDispositivo,
				modelPdfId: form.watch('modelOfPDF'),
				usuarioId: orderSelected?.fkUsuarioCel,
			},
		})

		if (data.body.includes('https')) {
			setTimeout(async () => {
				await deletePdfService({
					orderId: String(orderSelected?.idPedidoCel),
					usuarioId: orderSelected?.fkUsuarioCel,
				})
			}, 10000)
		}

		onClose()
	}

	return (
		<Dialog
			open={isOpen}
			onOpenChange={() => {
				onClose()
				setIsSuccessPDFDownload(false)
			}}
		>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>
						{isSuccessPDFDownload ? 'PDF gerado' : 'Gerar PDF'}
					</DialogTitle>
				</DialogHeader>

				<Form {...form}>
					<FormField
						control={form.control}
						name="modelOfPDF"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Selecionar modelo</FormLabel>
								<Select
									onValueChange={field.onChange}
									defaultValue={field.value}
								>
									<FormControl>
										<SelectTrigger>
											<SelectValue />
										</SelectTrigger>
									</FormControl>
									<SelectContent>
										<SelectItem value="1">PDF sem foto</SelectItem>
										<SelectItem value="2">PDF com foto</SelectItem>
									</SelectContent>
								</Select>
							</FormItem>
						)}
					/>

					<DialogFooter className="mt-3">
						<Button
							onClick={handleOpenPDF}
							disabled={orderSearchData.state.isLoadingRequestOrderPdf}
						>
							{orderSearchData.state.isLoadingRequestOrderPdf && (
								<Loader2 size={16} className="animate-spin mr-3" />
							)}
							{orderSearchData.state.isLoadingRequestOrderPdf
								? 'Gerando PDF'
								: 'Gerar PDF'}
						</Button>
					</DialogFooter>
				</Form>
			</DialogContent>
		</Dialog>
	)
}
